import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export default StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: 16,
    backgroundColor: themes.light.white[1],
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  hero: {
    width: 343,
    height: 120,
    marginBottom: 24,
  },
  title: {
    width: '100%',
    fontWeight: '700',
    marginBottom: 16,
  },
  bulletsContainer: {
    width: '100%',
    gap: 12,
    marginBottom: 24,
  },
  bulletItem: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  bulletIcon: {
    width: 20,
    height: 20,
    marginRight: 8,
  },
  bulletText: {
    flexShrink: 1,
  },
  fieldContainer: {
    width: '100%',
    marginBottom: 16,
  },
  orText: {
    textAlign: 'center',
    color: themes.light.gray[5],
    marginVertical: 16,
  },
  actions: {
    width: '100%',
    marginTop: 'auto',
    marginBottom: 16,
  },
  nextButton: {
    width: '100%',
  },
});
